/*

this component renders either the left or the right city navigation

*/

import React from 'react';
import content from '../content/content.js';

export default function CityNav(props) {

  var p = props.page;
  var d = props.direction;
  var t = props.type;
  var c;
  
  // city nav
  var cpcn = content.pages[p].citynav // current page
  if (p !== 0) { var ppcn = content.pages[p-1].citynav } // previous page
  if (p < content.pages.length-1) {var npcn = content.pages[p+1].citynav } // next page

  var winW = window.innerWidth;
  var line;
  if (winW < 500) {
    line = .9;
  } else if (winW < 750) {
    line = 1.1;
  } else if (winW < 1500) {
    line = 1.2;
  } else {
    line = 1.4;
  }


  // type 1: left
  if (t === '1') {
    if (d === 'next' && (cpcn === 'one' || cpcn === 'two') && ppcn === 'no'){
      c = 'nextIn'
    } else if (d === 'next' && (ppcn === 'one' || ppcn === 'two') && cpcn === 'no'){
      c = 'nextOut'
    }else if (d === 'prev' && (cpcn === 'one' || cpcn === 'two') && npcn === 'no'){
      c = 'prevIn'
    } else if (d === 'prev' && (npcn === 'one' || npcn === 'two') && cpcn === 'no'){
      c = 'prevOut'
    } else if (cpcn === 'no'){
      c = 'hide'
    } else {
      c = 't1-error'
    }
  // type 2: right
  } else if (t === '2') {
    if (d === 'next' && (cpcn === 'two') && ppcn === 'no'){
      c = 'nextIn'
    } else if (d === 'next' && (ppcn === 'two') && cpcn === 'no'){
      c = 'nextOut'
    }else if (d === 'prev' && (cpcn === 'two') && npcn === 'no'){
      c = 'prevIn'
    } else if (d === 'prev' && (npcn === 'two') && cpcn === 'no'){
      c = 'prevOut'
    } else if (cpcn === 'no' || cpcn === 'one'){
      c = 'hide'
    } else {
      c = 't2-error'
    }
  } else {
    console.log('CityNav Error');
    c = 'error'
  }

  function pageChange(change){
    props.onChange(change);
  }

  return (

    <div className={'CityNav ' + c} id={"city"+t}>

      <button className="cityButton" onClick={() => pageChange({s: 'city'+t, v: 'prev'})}>
        <svg className="prevCity" xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15">
          <path d="M0,11,10,0,21,11" transform="translate(1 2)" fill="none" stroke="#000" strokeWidth={line} />
        </svg>
      </button>

      <span className="cityName" >{props.cities[props.city]}</span>

      <button className="cityButton" onClick={() => pageChange({s: 'city'+t, v: 'next'})}>
        <svg className="nextCity" xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15">
            <path d="M0,11,10,0,21,11" transform="translate(22 13) rotate(180)" fill="none" stroke="#000" strokeWidth={line}/>
        </svg>
      </button>

    </div>

  )

};
